import React from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { isValid } from '@totalsoft/pure-validations-react';
import UserAgendaComponent from './UserAgendaComponent';
import { Grid, Tooltip, Table, TableBody, TableCell, TableHead, TableRow } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import SaveIcon from '@mui/icons-material/Save';
import { sequence } from '@totalsoft/change-tracking-react';
import { IconButton } from '@totalsoft/rocket-ui';

export const UserAgendaListComponent = ({ userAgendaLens, onSave, saving, isDirtyInfo, validationInfo, onAddNewItem, deleteItem }) => {
  const { t } = useTranslation();

  return (
    <Grid container spacing={1} justifyContent='flex-end'>
      <Grid item>
        <Tooltip title={t('User.UserProfile.Agenda.Summary.AddButton')}>
          <IconButton color='primary' variant='text' onClick={onAddNewItem}>
            <AddIcon />
          </IconButton>
        </Tooltip>
      </Grid>
      <Grid item>
        <Tooltip title={t('User.UserProfile.Agenda.Summary.SaveButton')}>
          <IconButton color='primary' variant='text' onClick={onSave} disabled={saving || !isDirtyInfo || !isValid(validationInfo)}>
            <SaveIcon />
          </IconButton>
        </Tooltip>
      </Grid>
      <Grid item md={12}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>
                <strong>{t('User.UserProfile.Agenda.ContactName')}</strong>
              </TableCell>
              <TableCell>
                <strong>{t('User.UserProfile.Agenda.Email')}</strong>
              </TableCell>
              <TableCell></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {(userAgendaLens |> sequence).map((item, index) => {
              return (
                <UserAgendaComponent
                  key={index}
                  index={index}
                  itemLens={item}
                  validationInfo={validationInfo[index]}
                  deleteItem={deleteItem}
                />
              );
            })}
          </TableBody>
        </Table>
      </Grid>
    </Grid>
  );
};

UserAgendaListComponent.propTypes = {
  userAgendaLens: PropTypes.object.isRequired,
  onSave: PropTypes.func.isRequired,
  saving: PropTypes.bool.isRequired,
  validationInfo: PropTypes.object.isRequired,
  isDirtyInfo: PropTypes.bool.isRequired,
  deleteItem: PropTypes.func.isRequired,
  onAddNewItem: PropTypes.func.isRequired
};

export default UserAgendaListComponent;
